import { postWrapper } from '../wrapper/PostWrapper'
import { scrollListener } from './ScrollListener'
import { searchListener } from './SearchListener'
import { loaderComponent } from '../components/LoaderComponent'
class AsyncLoader {
	posts = []
	finished = false
	status = 'NEW'
	reset () {
		scrollListener.addListener()
		this.finished = false
		this.posts = []
		postWrapper.clear()
	}

	setWebsiteService (websiteService) {
		this.websiteService = websiteService
		return this
	}

	setFinished (finished) {
		this.finished = finished
		if (finished) scrollListener.removeListener()
		return this
	}

	setStatus (status) {
		if (this.status !== status) loaderComponent.handler(status)
		this.status = status
		return this
	}

	addEmpty (msg) {
		postWrapper.renderEmptyMessage(msg)
	}

	async loadMorePosts () {
		if (this.finished) {
			this.setStatus('DONE')
			return false
		}
		const posts = await this.websiteService.getPosts({
			offset: this.offset,
			search: this.search
		})
		posts.forEach(post => this.addPost(post))
		if (posts.length === 0) {
			this.addEmpty('Brak rekordow do wyświetlenia')
		}
		this.setStatus('DONE')
	}

	get offset () {
		return this.posts.length
	}

	get search () {
		return searchListener.input.value
	}

	addPost (post) {
		this.posts.push(post)
		postWrapper.render(post)
	}
}

const asyncLoader = new AsyncLoader()
export { AsyncLoader, asyncLoader }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/com_catalog_search_async/core/AsyncLoader.js